import { useEffect, useState } from 'react';

interface IProps {
	label: string;
	value: Date | null;
	changeValue: (input: Date | null) => void;
	weekPicker?: boolean;
}

const DateSelect = (props: IProps) => {
	const [rangeText, setRangeText] = useState<string>('');

	const getInputValue = () => {
		if (!props.value) return '';
		if (props.weekPicker) {
			const year = props.value.getFullYear();
			const week = getISOWeekNumber(props.value);
			return `${year}-W${String(week).padStart(2, '0')}`;
		}
		return props.value.toISOString().split('T')[0];
	};

	useEffect(() => {
		if (props.weekPicker && props.value) {
			const monday = new Date(props.value);
			const friday = new Date(monday);
			friday.setDate(monday.getDate() + 3);
			var day = new Date(monday);
			day.setDate(day.getDate() - 1);
			friday.setDate(friday.getDate());
			setRangeText(`${formatDate(day)} → ${formatDate(friday)}`);
		} else {
			setRangeText('');
		}
	}, [props.value, props.weekPicker]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (!e.target.value) {
			props.changeValue(null);
			setRangeText('');
			return;
		}

		if (props.weekPicker) {
			const [yearStr, weekStr] = e.target.value.split('-W');
			const monday = getMondayOfISOWeek(parseInt(weekStr, 10), parseInt(yearStr, 10));
			const friday = new Date(monday);
			friday.setDate(monday.getDate() + 4);

			// Pass monday to parent
			props.changeValue(monday);

			// Update range preview
			var day = new Date(monday);
			day.setDate(day.getDate() - 1);
			friday.setDate(friday.getDate());
			setRangeText(`${formatDate(day)} → ${formatDate(friday)}`);
		} else {
			props.changeValue(new Date(e.target.value));
		}
	};

	const getMinWeekValue = () => undefined;

	// --- Helpers ---
	const getISOWeekNumber = (date: Date) => {
		const tmp = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
		const dayNum = tmp.getUTCDay() || 7;
		tmp.setUTCDate(tmp.getUTCDate() + 4 - dayNum);
		const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
		return Math.ceil(((tmp.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
	};

	const getMondayOfISOWeek = (week: number, year: number) => {
		const simple = new Date(Date.UTC(year, 0, 4));
		const dayOfWeek = simple.getUTCDay() || 7;
		simple.setUTCDate(simple.getUTCDate() + (week - 1) * 7 - (dayOfWeek - 1));
		return new Date(simple.getFullYear(), simple.getMonth(), simple.getDate());
	};

	const formatDate = (d: Date) =>
		d.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }); // e.g. "21 Jan"

	return (
		<>
			<label>{props.label}</label>
			<div className="input-group">
				<input
					type={props.weekPicker ? 'week' : 'date'}
					className="form-control"
					value={getInputValue()}
					onChange={handleChange}
					min={getMinWeekValue()}
				/>
				{props.weekPicker && rangeText && (
					<span className="input-group-text">{rangeText}</span>
				)}
			</div>
		</>
	);
};
export default DateSelect;
